<div mat-dialog-content>
  <div id="map" class="map">
    <img style="position: relative;top: -55px;left: -30px" id="marker" src="https://cdn.mapmarker.io/api/v1/fa?size=61&icon=far%20fa-dot-circle&color=%230062B1&" />
  </div>
</div>
<div mat-dialog-actions>
  <button fxFlex mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Select Location</button>
</div>
